import { Moment } from 'moment';
import { Dispatch, SetStateAction } from 'react';
import { UserTableData } from '../../context/availabilityRedirection';
// import { locationProps } from '../VisitorAppointment/visitorAppointment';

export interface VisitorObject {
    firstName: string;
    lastName: string;
    phoneNumber: number;
    email: string;
    expectedMoveInDate: string;
    password: string;
    desiredNumBedrooms: { value: string; label: string };
    leadProperty: { value: string; label: string };
    leadPropertyLink: string;
    confirmPassword?: string;
    companyName?: string;
    pmsLeadSorce: {
        lead_name: string;
        lead_id: string;
        lead_PMS: string;
    };
}

export interface ErrorsObject {
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    email?: string;
    password?: string;
    confirmPassword?: string;
    expectedMoveInDate?: string;
    leadProperty?: string;
}

export interface MyObject {
    value: string;
    label: string;
    [key: string]: string | null;
}

export type Bedroom = {
    value: string;
    label: string;
};

export interface EditStateData {
    id: string;
    type: string;
}

export const bedroomData: Bedroom[] = [
    { value: 'Studio', label: 'Studio' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
];

export interface PhonenumberProps {
    number: string;
    contry: string;
    length: number;
    countryCode: string | undefined;
    dialCode: string | undefined;
    trimmedLength: number;
}

export interface CountryData {
    name: string;
    dialCode: string;
    countryCode: string;
    format: string;
}

export interface IVisitorPopup {
    title: string;
    message: string;
    setShowModalPopup: Dispatch<SetStateAction<boolean>>;
}

export interface ISelectedUserData {
    userData: UserTableData;
}

export interface UserData {
    name: string;
    email: string;
    contact: string;
    date: string;
    bedrooms: string;
    countryCode: number;
    locationName: string;
    companyName: string;
}

export interface unitsDataInterface {
    id: string;
    created_at: Date;
    updated_at: Date;
    price: number;
    name: string;
    size: number;
    rooms?: number;
    baths: number;
    status?: number;
    nickName?: string;
    locationId: string;
    deleteImage_url: string;
    adminId: string;
    image_url: string;
    unitYardiId: string;
    availabilityDate: Date;
    unitOccupancyStatus: string;
    unitLeasedStatus: string;
    locationName: string;
}
export interface ISelectProperty {
    setSelectedProperty: Dispatch<SetStateAction<string>>;
    selectedProperty?: string;
    onClickHandler: (location: locationProps) => void;
    // isPreventPointerEvents: (location: locationProps) => string | undefined;
    setAppointmentStep: any;
    appointmentStep: any;
}

export interface ISelectUser {
    setShowSearchResult: Dispatch<SetStateAction<boolean>>;
    setSelectedUser: Dispatch<SetStateAction<string>>;
    setUserData: Dispatch<SetStateAction<UserTableData>>;
    showSearchResult: boolean;
    setUserId: Dispatch<SetStateAction<string>>;
    setSearchText: Dispatch<SetStateAction<string>>;
    searchText: string | undefined;
}

export interface AppointmentPopupInterface {
    title: string;
    message: string;
    className?: string;
    setShowModalPopup: Dispatch<SetStateAction<boolean>>;
}

export interface visitorObj {
    id: string;
    fullName: string;
    email: string;
    password: string;
    stripeDocVerificationClientId: string;
    stripeCustomerId: string;
    phoneNumber: string;
    terms: number;
    resetToken: null | string;
    resetTokenExpirationAt: null | string;
    namePrefix: null | string;
    addressLine1: null | string;
    addressLine2: null | string;
    country: null | string;
    state: null | string;
    city: null | string;
    postalCode: null | string;
    expectedMoveInDate: string;
    leaseFromDate: null | string;
    leaseToDate: null | string;
    desiredNumBedrooms: string;
    desiredLeaseTerms: null | string;
    countryCode: number;
    firstName: string;
    middleName: string;
    lastName: string;
    locationId: string | null;
    locationName: string | null;
    pmsLeadSorce: any | null;
    companyName: string;
    accountCreationTime: string;
    realPageGuestCardId: string | null;
    applicationEventDate?: string | null;
    leaseSignEventDate?: string | null;
    timeZone: string;
    created_at: string;
    deActivateDate: string | null;
    deleted_at: string | null;
}

export interface locationProps {
    availability: string[];
    city: string;
    confirmText: string;
    country: string;
    created_at: string;
    description: string;
    id: string;
    images: string[];
    latitude: number;
    longitude: number;
    masterCode: string;
    name: string;
    provisioningId: number;
    state: string;
    street1: string;
    street2: string;
    streetNumber: string;
    timeZone: string;
    units: string[];
    updated_at: string;
    zip: string;
    lockerName: string;
}

export interface UnitProps {
    unitId: string;
    unitPrice: number;
    unitName: string;
    nickName: string;
    unitImages: string;
    unitSize: number;
    unitRooms: number;
    unitBaths: number;
}

export interface Location {
    value: string;
    label: string;
    id: string;
}

export interface ManagementCompany {
    value: string;
    label: string;
    id: string;
}

export interface Status {
    value: string;
    label: string;
}

export interface AppointmentProps {
    reservedDate: string;
    start_time: Moment | string;
    end_time: Moment | string;
    availabilityId: string;
    timestamp: number;
}

export interface LockerAvailability {
    openTime: number;
    closeTime: number;
    id: string;
}

export interface LeadSource {
    lead_id: string;
    lead_name: string;
    lead_PMS: string;
    value: string;
    label: string;
}

export interface MetricsExcelData {
    email: string;
    locationName: string;
    unitName: string;
    locker: number;
    userCreationTime: string;
    appointmentCreationTime: string;
    reservedDate: string;
    appointmentCancellationTime: string;
    appointmentRescheduledTime: string;
    formattedDuration: string;
    relativeStartTime: string;
    relativeEndTime: string;
    isApplyClicked: string;
    managementCompany: string;
}

export interface MetricsData {
    email: string;
    locationName: string;
    unitName: string;
    locker: number;
    userCreationTime: string;
    appointmentCreationTime: string;
    reservedDate: string;
    start_time?: string;
    end_time?: string;
    appointmentCancellationTime: string;
    appointmentRescheduledTime: string;
    formattedDuration: string;
    relativeStartTime: string;
    relativeEndTime: string;
    isApplyClicked: string;
    timeZone: string;
    managementCompany: string | null;
}
